import '../styles/fonts.css';
import '../styles/reset.css';
import '../styles/globals.css';
import { UserProvider } from '@auth-v2';
import { GlobalLoader } from '@loaders';
import { QueryClientProvider } from '@tanstack/react-query';

import { queryClient } from '@queries';
import { StoreProvider } from '@store';

import { ROUTES } from '../utils/routes';

import { HomeRouter } from './HomeRouter';

const authPaths = [ROUTES.LOGIN, ROUTES.REGISTER, ROUTES.CONFIRM, ROUTES.RESET_PASSWORD, ROUTES.QR_CODE];

function App() {
    return (
        <StoreProvider>
            <QueryClientProvider client={queryClient}>
                <UserProvider loginPath={ROUTES.LOGIN} authPaths={authPaths} qrCodePath={ROUTES.QR_CODE}>
                    <GlobalLoader>
                        <HomeRouter />
                    </GlobalLoader>
                </UserProvider>
            </QueryClientProvider>
        </StoreProvider>
    );
}

export default App;
